import Page1 from "../images/page1.jpeg";
import Page2 from "../images/page2.jpeg";
import { IHighlightDataModel, IPageDataModel } from "../tsmodels/SharedModel";

export const scaleTransformOptions = [
  { scale: .25, x: "-139%", y: "-149%" },
  { scale: .5, x: "-45%", y: "-50%" },
  { scale: .75, x: "-12%", y: "-16%" },
  { scale: 1, x: "0%", y: "0%" },
  { scale: 1.25, x: "12%", y: "10%" },
  { scale: 1.5, x: "3%", y: "17%" },
  { scale: 1.75, x: "-5%", y: "22%" },
]

export const pagesData: IPageDataModel[] = [
  { page: 1, image: Page1 },
  { page: 2, image: Page2 },
];

export const highlightsData: IHighlightDataModel[] = [
  {
    page: 1,
    data: [
      {
        id: "048c124a-085a-4f0b-8ecd-d9b95ce3d59f",
        coordinates: {
          x: 86,
          y: 205,
          w: 206,
          h: 12,
        },
      },
      {
        id: "88d4b6a2-5693-418a-a2c1-1404679ed924",
        coordinates: {
          x: 330,
          y: 304,
          w: 222,
          h: 11,
        },
      },
      {
        id: "a7f75019-2b09-4444-8fce-36ba2c641340",
        coordinates: { x: 94, y: 43, w: 149, h: 12 },
      },
    ],
  },
  {
    page: 2,
    data: [
      {
        id: "4568322f-da64-4b66-bae3-59c73a30e089",
        coordinates: { x: 150, y: 150, w: 100, h: 25 },
      },
      {
        id: "4191bad6-fee7-4482-af10-59a236c0afc7",
        coordinates: { x: 300, y: 350, w: 150, h: 30 },
      },
      {
        id: "bf3d5e6e-31f3-453b-8350-6fcb9a80553a",
        coordinates: { x: 100, y: 200, w: 100, h: 20 },
      },
    ],
  },
];
